import { useMutation, useQuery } from "@tanstack/react-query"
import {
  getOrdersByAccessionNumber,
  getReportMessageText,
  getOrderMessageText,
  getAckMessageText,
} from "../api/orders"
import { formatISODate } from "../utils/datetime"

export const useOrdersByAccessionNumber = () =>
  useMutation({
    mutationFn: getOrdersByAccessionNumber,
  })

export const useReportMessageTextQuery = ({
  InboundMessageId,
  InboundMessageTextId,
}) =>
  useQuery({
    queryKey: ["report-message-text", InboundMessageId, InboundMessageTextId],
    queryFn: () => getReportMessageText(InboundMessageId, InboundMessageTextId),
    select: (res) => res.data,
    enabled: InboundMessageId !== null && InboundMessageTextId !== null,
  })

export const useOrderMessageTextQuery = ({
  OrderId,
  OrderTextId,
  source,
  PatientIssuer,
}) =>
  useQuery({
    queryKey: [
      "order-message-text",
      OrderId,
      OrderTextId,
      source,
      PatientIssuer,
    ],
    queryFn: () =>
      getOrderMessageText(OrderId, OrderTextId, source, PatientIssuer),
    select: (res) => res.data,
    enabled: OrderId !== null && OrderTextId !== null,
  })

export const useAckMessageTextQuery = ({
  OrderId,
  OrderAckId,
  source,
  PatientIssuer,
}) =>
  useQuery({
    queryKey: ["ack-message-text", OrderId, OrderAckId, source, PatientIssuer],
    queryFn: () =>
      getAckMessageText(OrderId, OrderAckId, source, PatientIssuer),
    select: (res) => res.data,
    enabled: OrderId !== null && OrderAckId !== null,
  })

const dateTimeFormat = "MM/dd/yyyy HH:mm:ss.SSS"
export const toOrder = (orderApiDto) => ({
  ...orderApiDto,
  orderReceivedFromCustomerAt: formatISODate(
    orderApiDto?.OrderRcvdFromCustomer,
    dateTimeFormat
  ),
  ackSentToCustomerAt: formatISODate(
    orderApiDto?.AckSentToCustomer,
    dateTimeFormat
  ),
  orderSentToMainMirthAt: formatISODate(
    orderApiDto?.OrderSentToMainMirth,
    dateTimeFormat
  ),
  ackReceivedFromMainMirthAt: formatISODate(
    orderApiDto?.AckRcvdFromMainMirth,
    dateTimeFormat
  ),
  orderReceivedFromClientAt: formatISODate(
    orderApiDto?.OrderRcvdAt,
    dateTimeFormat
  ),
  ackSentToClientAt: formatISODate(orderApiDto?.AckSentAt, dateTimeFormat),
  orderSentToRamsoftAt: formatISODate(
    orderApiDto?.OrderSentToRSAt,
    dateTimeFormat
  ),
  ackReceivedFromRamsoftAt: formatISODate(
    orderApiDto?.AckRcvdFromRSAt,
    dateTimeFormat
  ),
})

export const toResult = (resultApiDto) => ({
  ...resultApiDto,
  msgReceivedOnClientMirth: formatISODate(
    resultApiDto?.MsgRcvdFromMainMirth,
    dateTimeFormat
  ),
  ackSentToMainMirth: formatISODate(
    resultApiDto?.AckSentToMainMirth,
    dateTimeFormat
  ),
  msgSentToCustomer: formatISODate(
    resultApiDto?.MsgSentToCustomer,
    dateTimeFormat
  ),
  ackReceivedFromCustomer: formatISODate(
    resultApiDto?.AckRcvdFromCustomer,
    dateTimeFormat
  ),
  ackReceivedFromClientMirth: formatISODate(
    resultApiDto?.AckRcvdFromClientMirth,
    dateTimeFormat
  ),
  receivedFromRamsoftAt: formatISODate(
    resultApiDto?.RcvdFromRSAt,
    dateTimeFormat
  ),
  ackSentToRamsoftAt: formatISODate(
    resultApiDto?.AckSentToRSAt,
    dateTimeFormat
  ),
  updatedReportSentToRamsoftAt: formatISODate(
    resultApiDto?.UpdatedReportSentToRSAt,
    dateTimeFormat
  ),
  ackReceivedFromRamsoftAt: formatISODate(
    resultApiDto?.AckRcvdFromRSAt,
    dateTimeFormat
  ),
})
